export default "__VITE_ASSET__4D4OLFeP__"